/* global $ */
import { Component, Fragment } from 'preact';
import { Text, withText } from 'preact-i18n';
import getCalendarRanges from '../utils/getCalendarRanges';
import stringToDate from '../utils/stringToDate';
import 'script-loader!pickadate/lib/compressed/picker';
import 'script-loader!pickadate/lib/compressed/picker.date';
import dayjs from 'dayjs';
import DatesControls from './DatesControls';
import { selectIcon } from '../templates/place';
import { withGrowthBookFeatures } from '../context/GrowthBook';
import mixpanelTracker from '../utils/mixpanelTracker';
import getProductType from '../utils/getProductType';

const CALENDAR_BUTTONS_EVENT = 'Calendar Button Clicked';

class Datepicker extends Component {
  constructor(props) {
    super(props);
    this.onAlternativeDatesClick = this.onAlternativeDatesClick.bind(this);
    this.handleOnClean = this.handleOnClean.bind(this);
    this.handleOnDateButtonClick = this.handleOnDateButtonClick.bind(this);
    this.compactDateUsed = false;
    this.calendarButtonClicked = '';
    this.state = {
      isFocused: false
    };
  }

  componentDidMount() {
    const {
      field,
      onClose,
      hide = false,
      date,
      maxDaysSearch,
      dateFormat,
      setDeparturePicker,
      way,
      calendarOpen,
      onDatePickerCreated,
      onSelect,
      skipInitialValidation = false,
    } = this.props;

    // This prevents datepicker fields from being emptied when we don't have
    // the correct maxDaysSearch information yet (e.g., when destination has dynamic maxDays)
    let minMax = {};
    if (!skipInitialValidation) {
      const { min, max } = getCalendarRanges(maxDaysSearch);
      minMax = { min, max };
    }

    this.$input = $(this.fieldWrapperEl).find(`input.${field}`);
    this.$input.pickadate({
      ...minMax,
      ...(field !== 'returnDate' && { clear: false }),
      onClose: () => {
        onClose(this.$input.val());
        this.setState(() => ({ isFocused: false }));
      },
      onOpen: () => {
        this.setState(() => ({ isFocused: true }));
      },
      onSet: () => {
        if (onSelect) onSelect('personalized');
        if (this.calendarButtonClicked !== 'today' && this.calendarButtonClicked !== 'tomorrow')
          mixpanelTracker.trackEvent(CALENDAR_BUTTONS_EVENT, { type: 'personalized' });
        this.compactDateUsed = true;
      },
      ...(dateFormat && { format: dateFormat }),
    });
    this.$input.on('changeDepartureDate', this.changeDepartureDate);
    this.$input.on('changeReturnDate', this.changeReturnDate);
    this.$input.on('clearDate', this.handleOnClean);

    if (way === 'departure') setDeparturePicker(this.$input);
    if (date) {
      this.compactDateUsed = true;
      this.setDate(date);
    }

    if (hide) {
      this.$input.hide();
    }

    if (onDatePickerCreated) onDatePickerCreated(way);
    this.setOpenTicketBtn(field, calendarOpen);
    this.setDatePickerText(field);

    // Moving the calendar to the portal
    const isMobile = getProductType() === 'web-mobile';
    if (isMobile) {
      $('.picker').appendTo($('#reservamosPortal'));
    }
  }

  componentDidUpdate(prevProps) {
    const { field, calendarOpen, autoOpenCalendar, date } = this.props;

    if (date && !prevProps.date) {
      this.setDate(date);
    }
    // If the autoOpenCalendar changes to true, the calendar is opened
    if (!prevProps.autoOpenCalendar && autoOpenCalendar) {
      this.$input?.click();
    }

    this.setOpenTicketBtn(field, calendarOpen);
    if (
      !this.$input
        .parent()
        .find('.picker')
        .find('.datePickerTextContainer').length
    )
      this.setDatePickerText(field);
  }

  setOpenTicketBtn(field, calendarOpen) {
    const {
      openTicketText,
      openTicketAdText,
      openTicketDepartureText,
      openTicketReturnText,
      newText,
      way,
    } = this.props;
    if (!calendarOpen || this.openButtonInserted) {
      return;
    }

    const button = $('<button />', {
      class: 'picker-ticket-button',
      text: openTicketText,
      tabindex: '-1',
    });
    button.on('click', () => this.setOpenDate());
    const askText = way === 'departure' ? openTicketDepartureText : openTicketReturnText;
    $(this.$input)
      .parent()
      .find('.picker__box').after(`
        <div class="picker-ticket">
          <div class="picker-ticket-wrapper">
            <p><b>${askText}</b></p>
            <p>${openTicketAdText}</p>
            <span class="picker-ticket-new">
              ${newText}!
            </span>
          </div>
        </div>
      `);
    $(this.$input)
      .parent()
      .find('.picker-ticket-wrapper')
      .after(button);

    this.openButtonInserted = true;
  }

  setOpenDate() {
    const { openTicketText, onOpenTicketDate } = this.props;
    // Set the input value to be open ticket
    this.$input.val(openTicketText);
    // Close the picker
    this.$input.pickadate('picker').close();

    if (typeof onOpenTicketDate === 'function') {
      onOpenTicketDate();
    }
  }

  setDatePickerText(field) {
    const { departureDatePickerText, returnDatePickerText, title } = this.props;

    const datePickerText =
      field === 'departureDate' ? departureDatePickerText : returnDatePickerText;

    $(this.$input)
      .parent()
      .find('.picker__box').before(`
        <div class="datePickerTextContainer">
          <div class="calendar-heading">
            <p class="calendar-heading-title">${title}</p>
            ${
              datePickerText
                ? `<div class="calendar-heading-message">
                  <label>${datePickerText}</label>
                </div>`
                : ''
            }
          <div/>
        </div>
      `);
  }

  setDate(value) {
    const { openTicketText, dateFormat } = this.props;

    if (value === openTicketText) {
      this.setOpenDate();
      return;
    }
    const newDate = stringToDate(value, dateFormat);

    this.$input
      .pickadate('picker')
      .set('select', [newDate.getFullYear(), newDate.getMonth(), newDate.getDate()], {
        muted: true,
      });
  }

  changeDepartureDate = (_, value) => {
    const { openTicketText, maxDaysSearch, dateFormat } = this.props;
    const departureDate = stringToDate(value, dateFormat);
    
    if (!departureDate) return;
    if (value === openTicketText) {
      // If the value is open ticket, set min date to be calendar ranges
      const { min } = getCalendarRanges(maxDaysSearch);
      this.$input.pickadate('picker').set('min', min, {
        muted: true,
      });
      return;
    }

    const newMin = [departureDate.getFullYear(), departureDate.getMonth(), departureDate.getDate()];
    this.$input
      .pickadate('picker')
      .set(
        'min',
        newMin,
        { muted: true }
      );
  };

  changeReturnDate = (_, value) => {
    const { openTicketText, maxDaysSearch, dateFormat } = this.props;
    const returnDate = stringToDate(value, dateFormat);

    if (!returnDate) return;

    // If the value is open ticket, set max date to be calendar ranges
    if (value === openTicketText) {
      const { max } = getCalendarRanges(maxDaysSearch);
      this.$input.pickadate('picker').set('max', max, {
        muted: true,
      });
      return;
    }

    const newMax = [returnDate.getFullYear(), returnDate.getMonth(), returnDate.getDate()];
    this.$input
      .pickadate('picker')
      .set('max', newMax, {
        muted: true,
      });
  };

  onAlternativeDatesClick = type => () => {
    this.calendarButtonClicked = type;
    const { onClose, onSelect } = this.props;
    const todayDate = dayjs();
    if (type === 'today') {
      this.$input.pickadate('picker').set('select', todayDate.toDate());
    }
    if (type === 'tomorrow') {
      this.$input.pickadate('picker').set('select', todayDate.add(1, 'day').toDate());
    }
    if (onSelect) onSelect(type);
    onClose(this.$input.val(), type);
    mixpanelTracker.trackEvent(CALENDAR_BUTTONS_EVENT, { type });
    this.compactDateUsed = true;
  };

  /**
   * Clear the datepicker
   * @param {Event} e - Event
   */
  handleOnClean = e => {
    const { onClose, field } = this.props;
    e.stopPropagation(); // Avoid propagation to the field, this avoids the calendar to be opened
    onClose('');
    this.$input.val('');
    const openCalendar = !e.keepCalendarClosed && field === 'departureDate';
    this.compactDateUsed = false;
    if (openCalendar) {
      this.$input.click();
    }
  };

  /**
   * Open the datepicker
   */
  handleOnDateButtonClick = () => {
    const { date, returnDate, field } = this.props;

    this.calendarButtonClicked = '';

    const showCompactDate =
      !date && field === 'departureDate' && !returnDate && !this.compactDateUsed;
    if (showCompactDate) this.$input.click();
  };

  // This was done because there are cases where two widget are in the same page
  handleOnLabelClick = () => {
    this.calendarButtonClicked = '';
    this.$input.click();
  };

  render({ field, error, placeholderContext }) {
    const { onFocus, disabled = false, label, date, returnDate } = this.props;
    const { isFocused } = this.state;
    const showCleanButton = Boolean(date);
    const showCompactDate =
      !date && field === 'departureDate' && !returnDate && !this.compactDateUsed;
    return (
      <div
        className={`${field}-wrapper ${isFocused ? 'focused' : ''}`}
        key={`${field}-wrapper`}
        ref={el => (this.fieldWrapperEl = el)}
        onClick={this.handleOnDateButtonClick}
      >
        <Fragment>
          {error && (
            <div
              className="icon-error"
              // eslint-disable-next-line react/no-danger
              dangerouslySetInnerHTML={{
                __html: selectIcon('error', false),
              }}
            />
          )}
          {showCompactDate && (
            <DatesControls
              label={<Text id="label.when_traveling" />}
              onDateClick={this.handleOnDateButtonClick}
              onTodayClick={this.onAlternativeDatesClick('today')}
              onTomorrowClick={this.onAlternativeDatesClick('tomorrow')}
            />
          )}
          {!showCompactDate && (
            <label
              className={`label label-dates ${error ? 'label-error' : ''}`}
              onClick={this.handleOnLabelClick}
            >
              <Text id={`label.${label}`} />
            </label>
          )}
          <input
            role="combobox"
            aria-readonly="true"
            aria-label={placeholderContext}
            type="text"
            className={`${field} ${showCompactDate ? 'hide' : ''}`}
            placeholder={placeholderContext}
            ct-datepicker="true" // Clicktripz
            onFocus={onFocus}
            disabled={disabled}
            id={`txtDate-${field}`}
          />
          {showCleanButton && (
            <div
              className="clean-place-input"
              onClick={this.handleOnClean}
              // eslint-disable-next-line react/no-danger
              dangerouslySetInnerHTML={{
                __html: selectIcon('cleanIcon', false),
              }}
            />
          )}
          {!showCompactDate && !date && (
            <div
              class="iqdropdown-selection"
              // eslint-disable-next-line react/no-danger
              dangerouslySetInnerHTML={{
                __html: selectIcon('arrow', false),
              }}
            />
          )}
        </Fragment>
      </div>
    );
  }
}

export default withText(props => ({
  placeholderContext: <Text id={`placeholder.${props.placeholder}`} />,
  openTicketText: <Text id={`label.open_ticket`} />,
  openTicketAdText: <Text id={`label.open_ticket_ad`} />,
  openTicketReturnText: <Text id={`label.open_ticket_return`} />,
  openTicketDepartureText: <Text id={`label.open_ticket_departure`} />,
  newText: <Text id={`label.new`} />,
}))(withGrowthBookFeatures(Datepicker));
